import { FunctionComponent } from 'react'

import useArticleSchema from '@hooks/useArticleSchema'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

import BrandBox from './layouts/BrandBox'
import DefaultArticleTextbox from './layouts/DefaultArticleTextbox'
import { ArticleTextBoxAPIProps } from './types'

const ArticleTextbox: FunctionComponent<ArticleTextBoxAPIProps> = ({
  body,
  title,
  buttonLabel,
  showButton,
  showExpanded,
  link,
  image,
  imageDark,
  type,
}) => {
  const isPromo = type === 'promo'

  const { alignment: imageAlignment = 'full-width' } = image ?? {}

  const textForSchema = `${title ? `<h3>${title}</h3>` : ''}${body}`
  useArticleSchema({ text: textForSchema })

  if (!body && !isPromo) {
    return null
  }

  return (
    <>
      {isPromo ? (
        <BrandBox
          body={body}
          title={title}
          buttonLabel={buttonLabel}
          showButton={showButton}
          link={link}
          image={image}
          imageDark={imageDark}
          imageAlignment={imageAlignment}
        />
      ) : (
        <DefaultArticleTextbox
          body={body}
          title={title}
          buttonLabel={buttonLabel}
          showButton={showButton}
          showExpanded={showExpanded}
          link={link}
          image={image}
          imageDark={imageDark}
          imageAlignment={imageAlignment}
        />
      )}
    </>
  )
}

const widget = {
  kind: ['widget', 'article-textbox'],
  component: ArticleTextbox,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
